<template>
  <div>
    <div
      v-if="loading"
      class="wg-row"
      style="align-items: center; justify-content: center; margin-top: 20px"
    >
      <vue-simple-spinner
        size="medium"
        :line-fg-color="appColor"
      ></vue-simple-spinner>
    </div>
    <template v-if="!loading">
      <!-- LOADING MODAL -->
      <wg-modal :simple="true" :width="'200px'" v-if="updating">
        <template slot="body">
          <div
            class="wg-row com-anm22-app-text-l"
            style="justify-content: center"
          >
            {{ $anm22.strLang(lang, "Loading...", "Elaborazione in corso...") }}
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div
            class="wg-row"
            style="align-items: center; justify-content: center"
          >
            <vue-simple-spinner
              size="medium"
              :line-fg-color="appColor"
            ></vue-simple-spinner>
          </div>
        </template>
      </wg-modal>
      <!-- COVER MODAL -->
      <cover-modal
        v-if="showCoverModal"
        :order="order"
        :contact="contact"
        @cover-modal-update="updateCoversModalData"
        @select-contact="selectContact"
        @reset-contact="resetContact"
      ></cover-modal>
      <!-- VARIATIONS MODAL -->
      <var-modal
        v-if="varModalElement"
        :show="showVarModal"
        :element="varModalElement"
        @set-variations="setVariations"
      ></var-modal>
      <wg-modal
        :width="'400px'"
        v-if="showClearListModal"
        @closeModal="showClearListModal = false"
      >
        <div
          slot="body"
          class="wg-row no-select"
          style="justify-content: center"
        >
          <div class="com-anm22-app-text-xl" style="margin-bottom: 20px">
            {{
              $anm22.strLang(
                lang,
                "Do you want to empty the list?",
                "Vuoi svuotare la lista articoli?"
              )
            }}
          </div>
          <div
            class="wg-row"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('tick')"
                class="btn"
                :title="$anm22.strLang(lang, 'Yes', 'Sì')"
                @click="
                  emptyCart();
                  showClearListModal = false;
                "
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Yes", "Sì") }}
              </div>
            </div>
            <div class="display-flex action-btn-with-desc">
              <img
                :src="$anm22.icons.getWorldIcon('deleteRed')"
                class="btn"
                :title="$anm22.strLang(lang, 'No', 'No')"
                @click="showClearListModal = false"
              />
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "No", "No") }}
              </div>
            </div>
          </div>
        </div>
      </wg-modal>
      <!-- NOTES MODAL -->
      <wg-modal
        v-if="showNotesModal"
        :width="'80%'"
        @closeModal="showNotesModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xxl no-select">
          {{ $anm22.strLang(lang, "Notes", "Note") }}
        </div>
        <textarea
          slot="body"
          style="
            max-width: 100%;
            width: 100%;
            height: 100px;
            border: 1px solid #ddd;
          "
          v-model="order.notes"
        ></textarea>
      </wg-modal>
      <!-- YB MODAL -->
      <wg-modal
        v-if="showYbModal"
        :width="'80%'"
        @closeModal="showYbModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xxl no-select">
          {{ $anm22.strLang(lang, "Select umbrella", "Seleziona ombrellone") }}
        </div>
        <div
          slot="body"
          class="wg-row"
          :style="{ height: Math.floor((windowHeight / 100) * 90) - 90 + 'px' }"
        >
          <yb-map
            :mode="'delivery'"
            :selectRef="ybSelectRef"
            @yb-delivery="setYbDelivery"
          ></yb-map>
        </div>
      </wg-modal>
      <!-- TABLES MODAL -->
      <wg-modal
        :width="windowWidth > 900 ? '900px' : '90%'"
        v-if="showTableModal"
        @closeModal="showTableModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Tables map", "Mappa tavoli") }}
        </div>
        <div
          slot="body"
          class="wg-row"
          :style="{ height: Math.floor((windowHeight / 100) * 90) - 90 + 'px' }"
        >
          <tables-manage
            :tableRef="order.tableRef"
            :freeFn="setTable"
            :occupiedFn="() => $anm22.eventBus.$emit('wg-modal-close')"
          ></tables-manage>
        </div>
      </wg-modal>
      <!-- HOME DELIVERY MODAL MODAL -->
      <wg-modal
        v-if="showHomeDeliveryModal"
        :width="'320px'"
        @closeModal="showHomeDeliveryModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xxl no-select">
          {{ $anm22.strLang(lang, "Delivery address", "Dati di consegna") }}
        </div>
        <div
          slot="body"
          class="wg-row"
          style="margin-top: 10px; justify-content: center"
        >
          <input
            style="width: 300px"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            v-model="order.deliveryData.name"
          />
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 255px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
              v-model="order.deliveryData.street"
            />
            <input
              style="width: 40px; margin-left: 5px"
              type="text"
              placeholder="N."
              v-model="order.deliveryData.number"
            />
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="wg-row" style="flex-wrap: nowrap">
            <input
              style="width: 300px"
              type="text"
              :placeholder="
                $anm22.strLang(lang, 'Building/unit', 'Edificio/appartamento')
              "
              v-model="order.deliveryData.line2"
            />
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 215px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'City', 'Città')"
              v-model="order.deliveryData.city"
            />
            <input
              style="width: 80px; margin-left: 5px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
              v-model="order.deliveryData.zip"
            />
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 145px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
              v-model="order.deliveryData.state"
            />
            <select
              class="com-anm22-app-select"
              style="width: 150px; margin-left: 5px"
              v-model="order.deliveryData.country"
            >
              <option value="it" selected>
                {{ $anm22.strLang(lang, "Italy", "Italia") }}
              </option>
              <option value="rsm">
                {{
                  $anm22.strLang(
                    lang,
                    "Republic of San Marino",
                    "Republica di San Marino"
                  )
                }}
              </option>
            </select>
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 300px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Phone', 'Telefono')"
              v-model="order.deliveryData.phone"
            />
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 300px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Notes', 'Note')"
              v-model="order.deliveryData.notes"
            />
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <button class="small" @click="setDeliveryData">
            {{ $anm22.strLang(lang, "Confirm", "Conferma") }}
          </button>
        </div>
      </wg-modal>
      <!-- PICK-UP MODAL -->
      <wg-modal
        v-if="showPickUpPointModal"
        :width="'320px'"
        @closeModal="showPickUpPointModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xxl no-select">
          {{ $anm22.strLang(lang, "Pick-up Point", "Punto di ritiro") }}
        </div>
        <div
          slot="body"
          class="wg-row"
          style="margin-top: 10px; justify-content: center"
        >
          <div
            v-for="(point, i) in license.deliveryPickUpPoints"
            :key="'pup-' + i"
            class="pup-card"
            @click="setPickUpPointDelivery(point)"
          >
            <div
              :class="[
                point['it'] === order.pickUpPoint['it'] ? 'selected' : '',
              ]"
            >
              {{ point[lang] }}
            </div>
          </div>
        </div>
      </wg-modal>
      <!-- BUNGALOW MODAL -->
      <wg-modal
        v-if="showBungalowModal"
        :width="'320px'"
        @closeModal="showBungalowModal = false"
      >
        <div slot="header" class="com-anm22-app-text-xxl no-select">
          {{ $anm22.strLang(lang, "Bungalow address", "Indirizzo Bungalow") }}
        </div>
        <div
          slot="body"
          class="wg-row"
          style="margin-top: 10px; justify-content: center"
        >
          <input
            style="width: 300px"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            v-model="order.deliveryData.name"
          />
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 255px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
              v-model="order.deliveryData.street"
            />
            <input
              style="width: 40px; margin-left: 5px"
              type="text"
              placeholder="N."
              v-model="order.deliveryData.number"
            />
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 300px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Phone', 'Telefono')"
              v-model="order.deliveryData.phone"
            />
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <div class="display-flex" style="flex-wrap: nowrap">
            <input
              style="width: 300px"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Notes', 'Note')"
              v-model="order.deliveryData.notes"
            />
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <button class="small" @click="setBungalowDelivery">
            {{ $anm22.strLang(lang, "Confirm", "Conferma") }}
          </button>
        </div>
      </wg-modal>
      <!-- MAIN PAGE -->
      <div
        :class="[
          'wg-row',
          license.employeeOrderView ? 'employee-single-view' : '',
        ]"
        style="justify-content: space-between; align-items: center"
      >
        <div class="wg-col wg-xs-12 wg-md-7 fc-product-div-new">
          <mobile-title-bar
            :order="order"
            :elements="elements.length"
            :alwaysVisible="true"
            @open-cart="openCart"
            @open-cover-modal="showCoverModal = true"
          ></mobile-title-bar>
          <div
            class="com-anm22-food-scrolling-panel"
            :style="{ height: productsHeight + 'px' }"
          >
            <products
              :style="{ height: '100%' }"
              :elements="elements"
              @add-element="addElement"
            ></products>
          </div>
        </div>
        <div
          :class="[
            'wg-xs-12',
            'wg-md-5',
            'com-anm22-food-scrolling-panel',
            'com-anm22-food-fc-control-panel-new',
            cartOpen === null ? '' : cartOpen ? 'slide-in' : 'slide-out',
          ]"
        >
          <div class="no-select fc-cp-articles">
            <!-- <div 
                class="fc-article-label wg-row wg-md-none"
                style="height:40px;flex-wrap:nowrap;align-items:flex-end;justify-content:flex-end;">
              <div
                  class="com-anm22-app-text-l"
                  style="cursor:pointer;border:1px solid #ccc;padding:5px;border-radius:4px;margin-right: 10px;"
                  @click="closeCart">
                {{ $anm22.strLang(lang, 'Close', 'Chiudi') }}
              </div>
            </div> -->
            <div
              class="wg-row wg-p-xs-20 com-anm22-food-scrolling-panel articles-overflow"
              :style="{
                flexDirection: 'column',
                flexWrap: 'nowrap',
                minHeight: '140px',
                height: cartHeight + 'px',
              }"
            >
              <div style="width: 100%; flex: 2">
                <div
                  v-if="order.covers[0].filter((c) => !c).length > 0"
                  class="wg-row"
                  style="margin-bottom: 5px; font-size: 18px"
                >
                  <div style="margin-right: 5px">
                    {{ order.covers[0].filter((c) => !c).length + "x" }}
                  </div>
                  <div>{{ $anm22.strLang(lang, "Cover", "Coperto") }}</div>
                  <div style="margin-left: auto">
                    {{
                      Number(
                        order.covers[0].filter((c) => !c).length *
                          order.covers[1]
                      ).toFixed(2) + " €"
                    }}
                  </div>
                </div>
                <template v-for="s in order.maxSequence">
                  <div
                    :key="'sequence-' + s"
                    class="sequence-div wg-row com-anm22-food-seq-div"
                    @click="selectSequence(s)"
                    :style="{ color: sequence === s ? '#2196F3' : '#ccc' }"
                  >
                    {{ $anm22.strLang(lang, "Sequence", "Sequenza") + " " + s }}
                    <img
                      v-if="s <= order.printedSequence"
                      :src="$anm22.icons.getWorldIcon('runningMan')"
                      class="com-anm22-app-img-fixed-height-s"
                      style="margin-left: 10px"
                    />
                  </div>
                  <item-row
                    v-for="(row, index) in toPayRows[s]"
                    :key="s + '-row-' + index"
                    :row="row"
                    @change-row-weight="changeRowWeight"
                    @delete-article="deleteArticle"
                  ></item-row>
                  <div
                    :key="s + '-row-space-after'"
                    class="vertical-height-div"
                    style="height: 10px"
                  ></div>
                </template>
              </div>
              <template v-if="payed.length > 0">
                <div class="vertical-height-div" style="height: 10px"></div>
                <div
                  class="wg-row com-anm22-app-text-l"
                  style="
                    padding-bottom: 2px;
                    margin-bottom: 5px;
                    border-bottom: 1px solid #ccc;
                  "
                >
                  {{ $anm22.strLang(lang, "Payed", "Pagato") }}
                </div>
                <div style="width: 100%; flex: 2">
                  <div
                    v-if="order.covers[0].filter((c) => c).length > 0"
                    class="wg-row"
                    style="margin-top: 12px; font-size: 18px"
                  >
                    <div style="margin-right: 5px">
                      {{ order.covers[0].filter((c) => c).length + "x" }}
                    </div>
                    <div>{{ $anm22.strLang(lang, "Cover", "Coperto") }}</div>
                    <div style="margin-left: auto">
                      {{
                        Number(
                          order.covers[0].filter((c) => c).length *
                            order.covers[1]
                        ).toFixed(2) + "€"
                      }}
                    </div>
                  </div>
                  <item-row
                    v-for="(row, index) in payedRows"
                    :key="'payed-row-' + index"
                    :row="row"
                  ></item-row>
                </div>
              </template>
            </div>
            <div
              class="wg-row no-select"
              style="
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                padding: 5px 10px;
              "
            >
              <div
                class="display-flex action-btn"
                @click="showClearListModal = true"
                :title="$anm22.strLang(lang, 'Empty cart', 'Svuota carrello')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('emptyCart')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
              <div
                class="display-flex action-btn"
                @click="showCoverModal = true"
                :title="$anm22.strLang(lang, 'Covers', 'Coperti')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('multiUser')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
              <div
                class="display-flex action-btn"
                @click="newSequence"
                :title="$anm22.strLang(lang, 'New sequence', 'Nuova sequenza')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('listAdd')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
              <div
                class="display-flex action-btn"
                @click="showNotesModal = true"
                :title="$anm22.strLang(lang, 'Notes', 'Note')"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('sheet')"
                  class="com-anm22-app-img-fixed-height-l"
                />
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row" style="padding: 0 10px 0 10px">
            <div
              v-if="order.deliveryPrice"
              class="wg-row"
              :style="{
                alignItems: 'baseline',
                marginBottom: '4px',
                flexWraps: 'nowrap',
                alignItems: 'center',
              }"
            >
              <div
                class="wg-col wg-xs-6 display-flex"
                style="flex-wrap: nowrap; align-items: center"
              >
                <!-- <label
                  v-if="!order.deliveryPayment"
                  class="com-anm22-app-pointer fc-delivery-label"
                  style="margin:0 5px 0 0;object-fit:contain;"
                >
                  <img
                    v-if="!ignoreDeliveryPrice"
                    :src="$anm22.icons.getWorldIcon('tick')"
                    style="height:100%;width:100%;"
                  />
                  <input
                    type="checkbox"
                    id="delivery-checkbox"
                    @change="ignoreDeliveryPrice = !ignoreDeliveryPrice"
                    style="display:none;"
                    :disabled="order.deliveryPayment !== ''"
                  />
                </label> -->
                <div class="com-anm22-app-text-xl">
                  {{
                    $anm22.strLang(lang, "Delivery cost:", "Costo di consegna:")
                  }}
                </div>
              </div>
              <div
                class="wg-col wg-xs-6 display-flex"
                style="
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <div class="com-anm22-app-text-xl">
                  {{ order.deliveryPrice.toFixed(2) }}
                </div>
                <div class="com-anm22-app-text-xl" style="margin-left: 12px">
                  EUR
                </div>
              </div>
            </div>
            <div class="wg-row" style="align-items: baseline">
              <div class="wg-col wg-xs-6">
                <div class="com-anm22-app-text-xl">
                  {{ $anm22.strLang(lang, "Total:", "Totale:") }}
                </div>
              </div>
              <div
                class="wg-col wg-xs-6 display-flex"
                style="
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <div class="com-anm22-app-text-xl" id="totalOrder">
                  {{ totalOrder.toFixed(2) }}
                </div>
                <div class="com-anm22-app-text-xl" style="margin-left: 12px">
                  EUR
                </div>
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-horizontal-line-light"></div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-between;
              padding: 0 10px;
            "
          >
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, "Delivery", "Consegna") }}
            </div>
            <div
              v-if="order.deliveryType !== 5"
              class="display-flex"
              style="
                width: 60%;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div class="com-anm22-app-text-xl">
                {{ $anm22.strLang(lang, "Time", "Orario") }}
              </div>
              <select
                class="com-anm22-app-select"
                style="width: 80%; margin-left: 10px"
                v-model="order.deliveryTime"
              >
                <option value="" selected disabled>
                  {{ $anm22.strLang(lang, "Select one", "Seleziona") }}
                </option>
                <option
                  v-for="(ds, i) in deliverySlots"
                  :disabled="!ds.free"
                  :key="'ds-' + i"
                  :value="ds.slot.unix()"
                >
                  {{ ds.slot.format("l LT") }}
                </option>
              </select>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row no-select"
            style="flex-wrap: nowrap; align-items: center"
          >
            <div
              class="wg-row"
              style="
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-around;
                border-top: 1px solid #ccc;
                border-right: 1px solid #ccc;
              "
            >
              <div
                v-for="(dt, index) in deliveryTypes.map((dt) =>
                  $anm22.tableClasses.worldDeliveryType().getById(dt)
                )"
                :key="'dt+' + index"
                :class="[
                  'wg-row',
                  'fc-cp-select',
                  order.deliveryType == dt.typeClass ? 'selected' : '',
                ]"
                @click="setDeliveryType(dt)"
              >
                <img
                  :src="$anm22.icons.getWorldIcon(dt.typeClassLiteral)"
                  :style="getDeliveryIconStyle(dt)"
                  :title="dt[lang]"
                />
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row" style="justify-content: center">
            <div class="com-anm22-app-text-xl">
              {{ deliveryLabel }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div class="wg-row no-select" style="position: relative">
            <div
              class="wg-row"
              :style="{
                justifyContent: 'space-around',
                pointerEvents: updating ? 'none' : 'auto',
              }"
            >
              <div class="display-flex action-btn-with-desc">
                <img
                  :src="$anm22.icons.getWorldIcon('tick')"
                  class="btn"
                  :title="
                    $anm22.strLang(lang, 'Confirm order', 'Conferma ordine')
                  "
                  @click="save"
                />
                <div class="vertical-height-div" style="height: 5px"></div>
                <div class="com-anm22-app-text-m">
                  {{ $anm22.strLang(lang, "Confirm order", "Conferma ordine") }}
                </div>
              </div>
              <div
                v-if="accessControl.fastCash && saved"
                class="display-flex action-btn-with-desc"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('menuRegister')"
                  class="btn"
                  :title="$anm22.strLang(lang, 'Go to register', 'Apri cassa')"
                  @click="goToFastCash"
                />
                <div class="vertical-height-div" style="height: 5px"></div>
                <div class="com-anm22-app-text-m">
                  {{ $anm22.strLang(lang, "Go to register", "Apri cassa") }}
                </div>
              </div>
              <div
                v-if="
                  license.printSequences &&
                  saved &&
                  order.printedSequence < order.maxSequence
                "
                class="display-flex action-btn-with-desc"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('arrowRight')"
                  class="btn"
                  :title="
                    $anm22.strLang(
                      lang,
                      'Next course',
                      'Marcia prossima sequenza'
                    )
                  "
                  @click="nextSequence"
                />
                <div class="vertical-height-div" style="height: 5px"></div>
                <div class="com-anm22-app-text-m">
                  {{
                    $anm22.strLang(
                      lang,
                      "Next course",
                      "Marcia prossima sequenza"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import CoverModal from "../../components/employee/CoverModal.vue";
import VarModal from "../../components/employee/VarModal.vue";
import MobileTitleBar from "../../components/employee/MobileTitleBar.vue";
import Products from "../../components/employee/Products.vue";
import ItemRow from "../../components/employee/TakeOrderItemRow.vue";
import TablesManage from "../../components/tables/TablesManage.vue";
import YbMap from "../../components/YbMap.vue";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    CoverModal,
    MobileTitleBar,
    Products,
    ItemRow,
    TablesManage,
    VarModal,
    YbMap,
  },
  data() {
    return {
      fromPath: "",
      loading: true,
      updating: false,
      saved: false,
      /* Apertura carrello (mobile) */
      cartOpen: null,
      newElementsInCart: false,
      /* Supporto */
      sequence: 1,
      /* Variabili per costi di consegna */
      // ignoreDeliveryPrice: false,
      /* Ordine ed elementi - vengono gestiti in copia dallo store o ex novo */
      order: null,
      elements: [],
      /* Coperti */
      showCoverModal: false,
      /* Variazioni */
      showVarModal: false,
      varModalElement: null,
      /*  */
      pin: "",
      showClearListModal: false,
      showNotesModal: false,
      showTableModal: false,
      showTableAliasModal: false,
      showYbModal: false,
      ybModalDeliveryType: 0,
      ybSelectRef: null,
      showHomeDeliveryModal: false,
      showBungalowModal: false,
      showPickUpPointModal: false,
      /* Aggiornamento quantità prodotti */
      productTimer: null,
      // Gestione contatto
      contact: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      licenseSelected: (state) => state.licenseSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
      isOffline: (state) => state.offline.isOffline,
      appColor: (state) => state.config.appColor,
    }),
    cartHeight() {
      return (
        this.windowHeight -
        (this.windowWidth >= 992 || !this.license.employeeOrderView
          ? 452
          : 362) -
        (this.order.deliveryPrice ? 27 : 0)
      );
    },
    productsHeight() {
      return this.windowHeight - 105;
    },
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.licenseSelected
      );
    },
    work() {
      return this.$store.getters["works/get"](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    paymentMethods() {
      return this.license.paymentMethods
        .filter((p) => p.admin || p.customer)
        .map((p) => p.id);
    },
    deliveryTypes() {
      return this.license.deliveryTypes
        .filter((d) => d.admin || d.customer)
        .map((d) => d.id);
    },
    deliveryPrices() {
      return this.license.deliveryPrices;
    },
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment.permission;
    },
    accessControl() {
      return this.$store.getters["foodAcs/get"](
        this.license.id + "-" + this.permission
      );
    },
    products() {
      return this.$store.getters["foodProducts/getByLicense"](
        this.license.id
      ).filter((p) => !p.deleted);
    },
    rooms() {
      return this.$store.getters["foodRooms/getByLicense"](
        this.license.id
      ).filter((r) => !r.deleted);
    },
    tables() {
      return this.$store.getters["foodTables/getByLicense"](
        this.license.id
      ).filter((t) => !t.deleted);
    },
    /* ARRAY DI GESTIONE DEGLI ELEMENTI DELL'ORDINE */
    toPay: function () {
      return this.elements
        .filter((e) => !e.payment)
        .sort((a, b) => a.product - b.product);
    },
    toPayRows: function () {
      /* Key: seq, val: rows */
      let maxSequence = 0;
      let result = [];
      for (let i = 1; i <= this.order.maxSequence; i++) {
        result[i] = [];
      }
      this.toPay.forEach((e) => {
        const sequence = e.sequence;
        if(sequence > maxSequence) {
          maxSequence = sequence;
        }
        if(!result[sequence]) {
          result[sequence] = [];
        }
        if (e.weight === "") {
          if (e.variations.length === 0) {
            /* cerco se una riga con questo prodotto è già presente nell'array */
            const found = result[sequence].findIndex(
              (row) =>
                row.elem.product === e.product &&
                row.elem.variations.length === 0
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              result[sequence][found].elem = e;
              result[sequence][found].onclick = this.openVarModal;
              result[sequence][found].quantity++;
              result[sequence][found].price += e.price;
            } else {
              result[sequence].push({
                elem: e,
                weightEdit: null,
                priceEdit: false,
                deletable: true,
                onclick: this.openVarModal,
                quantity: 1,
                weight: null,
                price: e.price,
              });
            }
          } else {
            result[sequence].push({
              elem: e,
              weightEdit: null,
              priceEdit: false,
              deletable: true,
              onclick: this.openVarModal,
              quantity: 1,
              weight: null,
              price: e.price,
            });
          }
        } else {
          result[sequence].push({
            elem: e,
            weightEdit: true,
            priceEdit: false,
            deletable: true,
            onclick: this.openVarModal,
            quantity: 1,
            weight: e.weight,
            price: e.price,
          });
        }
      });
      // Fix any inconsistency betweene sequence of elements and maxSequence
      if(this.order.maxSequence < maxSequence) {
        this.order.maxSequence = maxSequence;
      }
      return result;
    },
    payed: function () {
      return this.elements
        .filter((e) => e.payment)
        .sort((a, b) => a.product - b.product);
    },
    payedRows: function () {
      let result = [];
      this.payed.forEach((e) => {
        if (e.weight === "") {
          if (e.variations.length === 0) {
            /* cerco se una riga con questo prodotto è già presente nell'array */
            const found = result.findIndex(
              (row) =>
                row.elem.product === e.product &&
                row.elem.variations.length === 0
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              result[found].elem = e;
              result[found].quantity++;
              result[found].price += e.price;
            } else {
              result.push({
                elem: e,
                weightEdit: null,
                priceEdit: false,
                deletable: false,
                onclick: false,
                quantity: 1,
                weight: null,
                price: e.price,
              });
            }
          } else {
            result.push({
              elem: e,
              weightEdit: null,
              priceEdit: false,
              deletable: false,
              onclick: false,
              quantity: 1,
              weight: null,
              price: e.price,
            });
          }
        } else {
          result.push({
            elem: e,
            weightEdit: false,
            priceEdit: false,
            deletable: false,
            onclick: false,
            quantity: 1,
            weight: e.weight,
            price: e.price,
          });
        }
      });
      return result;
    },
    /* TOTALI */
    totalArticles: function () {
      let result = 0;
      //Articoli + variazioni
      this.toPay.forEach((e) => {
        result += e.price;
        e.variations.forEach((v) => {
          result += v.price;
        });
      });
      // Coperti
      result +=
        this.order.covers[0].filter((c) => !c).length * this.order.covers[1];
      //Costo di consegna
      if (
        this.order.deliveryPrice &&
        !this.order.deliveryPayment /*&& !this.ignoreDeliveryPrice*/
      ) {
        result += this.order.deliveryPrice;
      }
      return this.$anm22.round(result, 2);
    },
    totalToPay: function () {
      return this.$anm22.round(
        this.totalArticles - (this.totalArticles / 100) * this.order.discount,
        2
      );
    },
    totalOrder: function () {
      return this.$anm22.round(
        this.totalToPay + Number(this.order.payedTotal),
        2
      );
    },
    payments() {
      return this.$store.getters["foodPayments/getByOrder"](this.order.id);
    },
    deliveryLabel() {
      const dtLabel = this.$anm22.tableClasses
        .worldDeliveryType()
        .getById(this.order.deliveryType)[this.lang];
      switch (this.order.deliveryType) {
        case 1:
        case 2:
          const beach = this.$store.getters["works/get"](this.order.beach);
          return (
            dtLabel + " - " + beach.name + " - " + this.order.beachUmbrella
          );
          break;
        case 5:
          const table = this.tables.find((t) => t.id === this.order.tableRef);
          return dtLabel + " - " + (this.order.tableAlias || table.name);
          break;
        case 9:
          return dtLabel + " - " + this.order.pickUpPoint[this.lang];
          break;
        default:
          return dtLabel;
      }
    },
    deliverySlots() {
      return this.$anm22.food_getDeliverySlots({
        vue: this,
        license: this.license,
        timezone: this.timezone,
        isCustomer: false,
      });
    },
  },
  methods: {
    getDeliveryIconStyle(dt) {
      switch (dt.typeClass) {
        case 1:
        case 4:
          return { width: "45px" };
        case 3:
          return { width: "35px" };
        case 2:
        case 8:
        case 9:
        case 10:
          return { width: "40px" };
        default:
          return { width: "50px" };
      }
    },
    openCart() {
      this.cartOpen = true;
      this.newElementsInCart = false;
    },
    closeCart() {
      this.cartOpen = false;
    },
    checkProducts() {
      clearTimeout(this.productTimer);
      this.productTimer = setTimeout(() => {
        this.$http
          .post("fast-cash/check-products", {
            elements: this.toPay,
          })
          .then((response) => {
            response.forEach((item) => {
              // Aggiorno il prodotto
              const product = this.products.find((p) => p.id === item.idProd);
              if (product) {
                product.quantity = item.qnt;
                this.$store.dispatch("foodProducts/update", {
                  vlf: this.$vlf("foodProducts"),
                  objs: [product],
                });
                if (item.over) {
                  this.$anm22.eventBus.$emit("world-headbar-show-message", {
                    text: this.$anm22.strLang(
                      this.lang,
                      "Only " +
                        product.quantity +
                        (product.stockType === 2
                          ? " units of "
                          : " " +
                            this.$anm22.tableClasses
                              .foodUnitOfMeasurement()
                              .getById(product.uom)[this.lang] +
                            "s of ") +
                        product.name +
                        " in stock",
                      "Solo " +
                        product.quantity +
                        (product.stockType === 2
                          ? " unità di "
                          : " " +
                            this.$anm22.tableClasses
                              .foodUnitOfMeasurement()
                              .getById(product.uom)[this.lang] +
                            "s di ") +
                        product.name +
                        " in magazzino"
                    ),
                    type: "alarm",
                  });
                }
              }
            });
          })
          .catch((error) => {});
      }, 500);
    },
    emptyCart() {
      this.elements = this.elements.filter((e) => e.payment);
      this.checkSequences();
    },
    newSequence() {
      if (
        this.toPay.filter((elem) => elem.sequence == this.order.maxSequence)
          .length === 0
      ) {
        return;
      }
      this.sequence = ++this.order.maxSequence;
    },
    selectSequence(sequence) {
      this.checkSequences();
      this.sequence = sequence;
    },
    checkSequences() {
      for (let s = this.order.maxSequence; s >= 1; s--) {
        let elems = this.toPay.filter((elem) => elem.sequence == s);
        if (
          elems.length === 0 &&
          s === this.order.maxSequence &&
          s > this.order.printedSequence &&
          s > 1
        ) {
          //questa sequenza deve essere eliminata
          if (this.sequence === s) {
            this.sequence--;
          }
          this.order.maxSequence--;
        }
      }
    },
    nextSequence() {
      this.save(async () => {
        try {
          const response = await this.$http.post("fast-cash/next-sequence", {
            orderId: this.order.id,
          });
          this.$store.dispatch("foodOrders/update", {
            vlf: this.$vlf("foodOrders"),
            objs: response.data.orders,
          });
        } catch (e) {
          await this.$anm22.nextSequence({
            vue: this,
            order: this.order,
            elements: this.elements,
          });
        } finally {
          this.order = this.$store.getters["foodOrders/get"](this.order.id);
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Preparing next course",
              "Sequenza successiva in marcia"
            ),
            type: "confirm",
          });
          this.updating = false;
        }
      });
    },
    goToFastCash() {
      this.$router
        .push("/fastCash/" + this.order.id)
        .catch((e) => console.log(e));
    },
    addElement(product) {
      const localId = this.$anm22.genLocalId();
      const weight = product.pricingType === 2 ? product.defaultQuantity : "";
      const price =
        product.pricingType === 2 ? product.price * weight : product.price;
      this.elements.push({
        id: localId,
        dbKey: localId,
        product: product.id,
        productName: product.langName,
        productUnitPrice: product.price,
        productVat: product.vat,
        productUom: product.uom,
        variations: [],
        weight,
        price,
        payment: "",
        toInsert: true,
        sequence: this.sequence,
        notes: "",
      });
      this.newElementsInCart = false;
      if (product.stockType !== 1) {
        this.checkProducts();
      }
    },
    deleteArticle(id) {
      const index = this.elements.findIndex((e) => e.id === id);
      if (-1 !== index) {
        const element = this.elements.splice(index, 1)[0];
        this.checkSequences();
        const product = this.products.find((p) => p.id === element.product);
        if (product && product.stockType !== 1) {
          this.checkProducts();
        }
      }
    },
    changeRowWeight(data) {
      const value = Number(data.event.target.value);
      if (value < 0) {
        value = 0;
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Articles cannot have a negative weight",
            "Gli articoli non possono avere peso negativo"
          ),
          type: "warning",
        });
      }
      const elem = this.elements.find((e) => e.id === data.id);
      const product = this.products.find((p) => p.id === elem.product);
      if (product.stockType !== 1 && product.quantity < value) {
        value = product.quantity;
      }
      elem.weight = this.$anm22.round(value, 2);
      elem.price = this.$anm22.round(elem.productUnitPrice * elem.weight, 2);
    },
    async updateCoversModalData(value) {
      this.showCoverModal = false;
      this.order.tableAlias = value.tableAlias;
      //Recupero il prezzo offline
      this.$set(this.order.covers, 0, value.covers);
      const now = this.$moment.tz(this.timezone);
      const switchTime = this.$moment.tz(
        this.license.coverSwitch,
        "HH:mm",
        this.timezone
      );
      const coverPrice = now.isBefore(switchTime, "hour minute second")
        ? this.license.lunchCover
        : this.license.dinnerCover;
      this.$set(this.order.covers, 1, coverPrice); // Aggiornamento contatto
      if (value.contact) {
        const response = await this.$http.post("contact/update-contact", {
          contact: value.contact,
        });
        if (response.data.error) {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Error saving contact info",
              "Errore al salvataggio del contatto"
            ),
            type: "alarm",
          });
          console.log(response.data.error);
          return;
        }
        this.contact = response.data.contact;
        this.order.contactId = response.data.contact.idContactsContact;
      }
    },
    selectContact(contact) {
      // Update order with contact id
      this.contact = contact;
      this.order.contactId = contact.idContactsContact;
    },
    resetContact() {
      this.contact = null;
      this.order.contactId = "";
    },
    openVarModal(elem) {
      if (elem) {
        this.varModalElement = elem;
        this.showVarModal = true;
      }
    },
    setVariations(vars) {
      this.showVarModal = false;
      const element = this.elements.find(
        (e) => e.id === this.varModalElement.id
      );
      if (-1 !== element) {
        element.variations = vars;
      }
      this.varModalElement = null;
    },
    setYbDelivery(data) {
      this.showYbModal = false;
      this.order.tableRef = null;
      this.order.deliveryPrice = this.deliveryPrices[this.ybModalDeliveryType];
      this.order.deliveryType = this.ybModalDeliveryType;
      this.order.beach = data.beachId;
      this.order.beachUmbrella = data.umbrella;
      this.ybModalDeliveryType = null;
    },
    setDeliveryType(dt) {
      if (dt.typeClass == 5) {
        this.showTableModal = true;
      } else if (dt.typeClass == 1 || dt.typeClass == 2) {
        this.ybModalDeliveryType = dt.typeClass;
        if (this.order.beach) {
          this.ybSelectRef = this.order.beach;
        }
        this.showYbModal = true;
      } else if (dt.typeClass == 7) {
        this.showHomeDeliveryModal = true;
      } else if (dt.typeClass == 9) {
        this.showPickUpPointModal = true;
      } else if (dt.typeClass == 10) {
        this.showBungalowModal = true;
      } else {
        this.order.deliveryType = dt.typeClass;
        this.order.deliveryPrice = this.deliveryPrices[dt.typeClass];
        this.order.tableRef = "";
        this.order.beach = "";
        this.order.beachUmbrella = "";
        this.order.pickUpPoint = "";
        this.order.deliveryData = { country: "it" };
      }
    },
    setTable(table) {
      this.showTableModal = false;
      // Reset
      this.order.beach = "";
      this.order.beachUmbrella = "";
      this.order.pickUpPoint = "";
      this.order.deliveryData = { country: "it" };
      // Set
      this.order.tableRef = table.id;
      this.order.deliveryType = 5;
      this.order.deliveryPrice = this.deliveryPrices[5];
      this.order.deliveryTime = "";
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    setHomeDelivery() {
      this.showHomeDeliveryModal = false;
      // Reset
      this.order.beach = "";
      this.order.beachUmbrella = "";
      this.order.tableRef = "";
      this.order.pickUpPoint = "";
      // Set
      this.order.deliveryType = 7;
      this.order.deliveryPrice = this.deliveryPrices[7];
    },
    setPickUpPointDelivery(point) {
      this.showPickUpPointModal = false;
      // Reset
      this.order.beach = "";
      this.order.beachUmbrella = "";
      this.order.tableRef = "";
      this.order.deliveryData = { country: "it" };
      // Set
      this.order.deliveryType = 9;
      this.order.deliveryPrice = this.deliveryPrices[9];
      this.$set(this.order, "pickUpPoint", { ...point });
    },
    setBungalowDelivery() {
      this.showBungalowModal = false;
      // Reset
      this.order.beach = "";
      this.order.beachUmbrella = "";
      this.order.tableRef = "";
      this.order.pickUpPoint = "";
      // Set
      this.order.deliveryType = 10;
      this.order.deliveryPrice = this.deliveryPrices[10];
    },
    async save(callback) {
      this.checkSequences();
      if (this.elements.length > 0) {
        if (!this.order.paymentMethod) {
          this.order.paymentMethod = 1;
        }
        if (!this.order.deliveryType) {
          this.order.deliveryType = 4;
        }
        if (this.order.deliveryType !== 5 && !this.order.deliveryTime) {
          const temp = this.$moment.tz(this.timezone);
          this.order.deliveryTime = temp
            .subtract(temp.minute() % 15, "minutes")
            .seconds(0)
            .unix();
        }
        this.checkAuth("", () => {
          this.updating = true;
          let data = {};
          this.$http
            .post("fast-cash/save", {
              pin: this.pin,
              order: this.order,
              elements: this.elements,
            })
            .then((response) => {
              if (!response.data.error) {
                Promise.all([
                  this.$store.dispatch("foodOrders/update", {
                    vlf: this.$vlf("foodOrders"),
                    objs: response.data.orders,
                  }),
                  this.$store.dispatch("foodOrderElements/update", {
                    vlf: this.$vlf("foodOrderElements"),
                    objs: response.data.orderElements,
                    // Per pulire elementi cancellati dal db
                    cleanFilters: [(e) => e.order === this.order.id],
                  }),
                ]).then(() => {
                  this.afterSave(
                    response.data.orders[0].id,
                    callback,
                    response.data.updatedIds
                  );
                });
              } else {
                this.updating = false;
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: response.data.error,
                  type: "alarm",
                });
              }
            })
            .catch((error) => {
              //Salvataggio offline dell'ordine
              this.$anm22
                .save({
                  vue: this,
                  license: this.license,
                  timezone: this.timezone,
                  order: this.order,
                  elements: this.elements,
                  pin: this.pin,
                })
                .then((orderId) => {
                  this.afterSave(orderId, callback);
                });
            });
        });
      } else {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "No elements in the cart!",
            "Nessun elemento nel carrello!"
          ),
          type: "alarm",
        });
      }
    },
    afterSave(orderId, callback, newIds) {
      this.order = this.$store.getters["foodOrders/get"](orderId);
      this.elements = this.$store.getters["foodOrderElements/getByOrder"](
        this.order.id
      );
      this.saved = true;
      /* Aggiorno l'url nella barra degli indirizzi */
      this.$route.params.id
        ? this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Order correctly edited!",
              "Ordine correttamente modificato"
            ),
            type: "confirm",
          })
        : this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Order registered!",
              "Ordine registrato!"
            ),
            type: "confirm",
          });
      if (this.$route.path !== "/takeOrder/" + orderId) {
        this.$router
          .replace("/takeOrder/" + orderId)
          .catch((e) => console.log(e));
      }
      if (typeof callback === "function") {
        if (newIds) {
          callback(newIds);
        } else {
          callback();
        }
      }
      this.pin = "";
      this.updating = false;
    },
    checkAuth(req, callback) {
      if (this.permission == "5" && this.pin === "") {
        const requestData = {
          acRequest: req,
          success: (pin) => {
            this.pin = pin;
            callback();
          },
          error: (pin) => {},
        };
        this.$anm22.eventBus.$emit("food-pin-authorization", requestData);
      } else {
        callback();
      }
    },
    initSecondaryData() {
      if (typeof this.order.paymentData !== Array) {
        this.order.paymentData = {};
      }
      /* Init sequenze e counter id */
      if (this.order.maxSequence < this.order.printedSequence) {
        this.order.maxSequence = this.order.printedSequence;
      }
      this.sequence = this.order.maxSequence;
      if (!this.saved) {
        this.showCoverModal = true;
      }
    },
    loadData() {
      return Promise.all([
        this.$store.dispatch("foodLicenses/load", this.$vlf("foodLicenses")),
        this.$store.dispatch(
          "foodEmployments/load",
          this.$vlf("foodEmployments")
        ),
        this.$store.dispatch("foodAcs/load", this.$vlf("foodAcs")),
        this.$store.dispatch(
          "foodCategories/load",
          this.$vlf("foodCategories")
        ),
        this.$store.dispatch("foodProducts/load", this.$vlf("foodProducts")),
        this.$store.dispatch("foodRooms/load", this.$vlf("foodRooms")),
        this.$store.dispatch("foodTables/load", this.$vlf("foodTables")),
        this.$store.dispatch("ybLicenses/load", this.$vlf("ybLicenses")),
        this.$store.dispatch("works/load", this.$vlf("works")),
        this.$store.dispatch("foodOrders/load", this.$vlf("foodOrders")),
        this.$store.dispatch(
          "foodOrderElements/load",
          this.$vlf("foodOrderElements")
        ),
        this.$store.dispatch("foodPayments/load", this.$vlf("foodPayments")),
      ]);
    },
    async loadPage() {
      // Recupero dati necessari
      let queryString = "";
      if (this.$route.params.id) {
        queryString += "orderId=" + this.$route.params.id;
      }
      try {
        const response = await this.$http.get("fast-cash?" + queryString);
        await Promise.all([
          this.$store.dispatch("foodLicenses/update", {
            vlf: this.$vlf("foodLicenses"),
            objs: [response.data.license],
          }),
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: [response.data.employment],
          }),
          this.$store.dispatch("foodCategories/update", {
            vlf: this.$vlf("foodCategories"),
            objs: response.data.categories,
            cleanFilters: [],
          }),
          this.$store.dispatch("foodProducts/update", {
            vlf: this.$vlf("foodProducts"),
            objs: response.data.products,
            cleanFilters: [],
          }),
          this.$store.dispatch("foodRooms/update", {
            vlf: this.$vlf("foodRooms"),
            objs: response.data.rooms,
            cleanFilters: [],
          }),
          this.$store.dispatch("foodTables/update", {
            vlf: this.$vlf("foodTables"),
            objs: response.data.tables,
            cleanFilters: [],
          }),
          this.$store.dispatch("ybLicenses/update", {
            vlf: this.$vlf("ybLicenses"),
            objs: response.data.ybLicenses,
          }),
          this.$store.dispatch("works/update", {
            vlf: this.$vlf("works"),
            objs: response.data.works,
          }),
          //Ordini delle ultime 24 ore + ordine richiesto
          this.$store.dispatch("foodOrders/update", {
            vlf: this.$vlf("foodOrders"),
            objs: response.data.orders,
          }),
          //Elemento ordine richiesto
          this.$store.dispatch("foodOrderElements/update", {
            vlf: this.$vlf("foodOrderElementss"),
            objs: response.data.orderElements,
            cleanFilters: [(e) => e.order == this.$route.params.id],
          }),
          this.$store.dispatch("foodPayments/update", {
            vlf: this.$vlf("foodPayments"),
            objs: response.data.payments,
            cleanFilters: [(p) => p.order === this.$route.params.id],
          }),
        ]);
        // Pay card
        if (response.data.card) {
          const card = response.data.card;
          card.isExpired = false;
          if (card.expirationDate) {
            const expiration = this.$moment
              .tz(card.expirationDate, "X", this.timezone)
              .endOf("day");
            const now = this.$moment.tz(this.timezone);
            if (now.isAfter(expiration)) {
              card.isExpired = true;
            }
          }
          card.selected = true;
          this.payHints.push(card);
        }
        if (response.data.contact) {
          this.contact = response.data.contact;
        }
      } catch (e) {}
      if (this.$route.params.id) {
        this.order = this.$store.getters["foodOrders/get"](
          this.$route.params.id
        );
        if (this.order) {
          this.elements = this.$store.getters["foodOrderElements/getByOrder"](
            this.order.id
          );
          this.saved = true;
        } else {
          this.$router.push("/takeOrder").catch((e) => console.log(e));
          return;
        }
      } else {
        const localId = this.$anm22.genLocalId();
        this.order = {
          id: localId,
          dbKey: localId,
          orderDate: "",
          lastModified: "",
          license: this.license.id,
          createdBy: this.user.idWorldUser,
          customer: "",
          status: 3,
          estimatedTime: "",
          isPaying: false,
          payed: false,
          deliveryPayment: false,
          paymentMethod: 1, //contanti
          paymentData: [],
          deliveryType: 4, //ritiro bar
          beach: "",
          beachUmbrella: "",
          tableRef: "",
          tableAlias: "",
          pickUpPoint: "",
          deliveryData: {
            country: "it",
          },
          deliveryTime: "",
          deliveryPrice: this.deliveryPrices[this.deliveryTypes[0]],
          surcharge: 0,
          discount: 0,
          totalVAT: 0,
          listTotal: 0,
          toPayTotal: 0,
          payedTotal: 0,
          receiptType: "",
          notes: "",
          printedSequence: 0,
          maxSequence: 1,
          printedSequenceTime: "",
          covers: [[], 0],
          invoice: "",
        };
        this.elements = [];
      }
      if (this.$route.query.tableId) {
        const table = this.$store.getters["foodTables/get"](
          this.$route.query.tableId
        );
        if (table) {
          this.setTable(table);
        }
      }
      if (this.$route.query.beachLicense && this.$route.query.umbrella) {
        const ybl = this.ybLicenses.find(
          (ybl) => ybl.ybLicense == this.$route.query.beachLicense
        );
        if (ybl) {
          this.order.paymentMethod = 7;
          this.order.paymentData = {
            beachId: ybl.beach,
            beachLicense: ybl.ybLicense,
            umbrella: this.$route.query.umbrella,
            registration: this.$route.query.registration,
          };
        }
      }
      this.initSecondaryData();
      this.loading = false;
      this.$Progress.finish();
      document.title = this.$anm22.strLang(this.lang, "Order", "Ordinazione");
      this.$store.dispatch(
        "headbar/setHeadbarTitle",
        this.$anm22.strLang(this.lang, "Order", "Ordinazione")
      );
    },
  },
  created() {
    if (!this.license.config.modules.tables.enabled) {
      this.$router.push("/").catch((e) => console.log(e));
      return;
    }
    this.loadPage();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
      vm.$store.dispatch("headbar/setBackHref", vm.fromPath);
    });
  },
  watch: {
    $route(to, from) {
      this.loadPage();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.cartOpen && to.path === this.fromPath) {
      this.closeCart();
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.fc-cp-select {
  &.disabled {
    opacity: 0.3;
    pointer-events: null;
  }
}
.action-btn {
  border-radius: 5px;
  background-color: #eee;
  padding: 10px;
  cursor: pointer;
  height: 50px;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  &:hover {
    box-shadow: 0 0 0 2px #2196f3;
  }
}
.action-btn-with-desc {
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  .btn {
    border-radius: 5px;
    background-color: #eee;
    padding: 10px;
    cursor: pointer;
    height: 80px;
    width: 80px;
    margin: 0 10px;
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
.pup-card {
  width: 100%;
  margin: 5px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 50px;
    font-size: 16px;
    border-radius: 10px;
    border: 1px solid #ccc;
    padding: 5px;
    cursor: pointer;
    &.selected {
      box-shadow: 0 0 0 2px #2196f3;
    }
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
</style>
